import { RootState } from "store";

import { get, isFunction } from "lodash-es";

import { getDefaultAttrs } from "./defaults";

type TrackedJourneyStartIds = "fulfillment";
type TrackedJourneyStepIds = "disclosure-agreement";

const startJourneyMap: Record<TrackedJourneyStartIds, (state: RootState) => unknown> = {
  fulfillment: (state: RootState) => {
    return {
      event: "fulfillment_started",
      attribute: {
        ...getDefaultAttrs(state, "ONBOARDING"),
      },
    };
  },
};

export const startJourney = (
  action: { [key: string]: unknown },
  prevState: RootState,
  nextState: RootState
) => {
  const key = get(action, "payload.id", "") as TrackedJourneyStartIds;
  if (key && isFunction(startJourneyMap[key])) {
    return startJourneyMap[key](nextState);
  }
};

const setJourneyStepMap: Record<TrackedJourneyStepIds, (state: RootState) => unknown> = {
  "disclosure-agreement": (state: RootState) => {
    return {
      event: "fulfillment_uw_started",
      attribute: {
        ...getDefaultAttrs(state, "ONBOARDING"),
      },
    };
  },
};

export const setJourneyStep = (
  action: { [key: string]: unknown },
  prevState: RootState,
  nextState: RootState
) => {
  const key = get(action, "payload.id", "") as TrackedJourneyStepIds;
  if (key && isFunction(setJourneyStepMap[key])) {
    return setJourneyStepMap[key](nextState);
  }
};
